import { Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LabelLayout } from '../../services/label-layout';
import { LabelPrintService } from '../../services/label-print.service';

/**
 * Put on every label page. While it is on screen the configured label size is applied
 * to the browser print dialog, and it tells the operator how to set that dialog up.
 */
@Component({
    selector: 'app-label-print-setup',
    templateUrl: './label-print-setup.component.html',
    standalone: false
})
export class LabelPrintSetupComponent implements OnInit, OnDestroy {

  layout: LabelLayout;

  private readonly destroyRef = inject(DestroyRef);

  constructor(private labelPrint: LabelPrintService) {
    this.layout = labelPrint.layout;
  }

  ngOnInit(): void {
    this.labelPrint.layout$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((layout) => this.layout = layout);

    this.labelPrint.activate();
  }

  ngOnDestroy(): void {
    this.labelPrint.deactivate();
  }
}
